import React from 'react';
import { CheckCircle, ArrowRight } from 'lucide-react';
import { Button } from './ui/Button';
import { motion } from 'framer-motion';
export function HeroSection() {
  const scrollToPricing = () => {
    const element = document.getElementById('pricing-cta');
    if (element) element.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative pt-32 pb-20 lg:pt-40 lg:pb-28 overflow-hidden" data-id="element-157">
      {/* Decorative Background Elements */}
      <div className="absolute top-0 right-0 -mr-20 -mt-20 w-96 h-96 bg-sage/10 rounded-full blur-3xl opacity-60 pointer-events-none" data-id="element-158" />
      <div className="absolute bottom-0 left-0 -ml-20 -mb-20 w-80 h-80 bg-terracotta/10 rounded-full blur-3xl opacity-60 pointer-events-none" data-id="element-159" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-160">
        <div className="max-w-3xl mx-auto text-center" data-id="element-161">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-162">
            <span className="inline-block py-1 px-3 rounded-full bg-terracotta/10 text-terracotta-dark text-sm font-semibold tracking-wide mb-6" data-id="element-163">
              Para madres que buscan tranquilidad
            </span>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-forest mb-6 leading-tight" data-id="element-164">
              Son las 2 de la mañana. <br className="hidden md:block" data-id="element-165" />
              Tu hijo tiene fiebre. <br className="hidden md:block" data-id="element-166" />
              <span className="text-terracotta italic" data-id="element-167">¿Sabes qué hacer?</span>
            </h1>

            <p className="text-lg md:text-xl text-forest/80 mb-8 leading-relaxed max-w-2xl mx-auto" data-id="element-168">
              PequeSalud Natural es tu guía paso a paso con opciones naturales
              complementarias para los síntomas más comunes de tus hijos.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8 mb-10 text-forest/90" data-id="element-169">
            <div className="flex items-center gap-2" data-id="element-170">
              <CheckCircle className="h-5 w-5 text-sage-dark flex-shrink-0" data-id="element-171" />
              <span data-id="element-172">Organizada por síntomas</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-173">
              <CheckCircle className="h-5 w-5 text-sage-dark flex-shrink-0" data-id="element-174" />
              <span data-id="element-175">Ingredientes simples de casa</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-176">
              <CheckCircle className="h-5 w-5 text-sage-dark flex-shrink-0" data-id="element-177" />
              <span data-id="element-178">Pasos claros para actuar</span>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="flex flex-col items-center gap-4" data-id="element-179">
            <div className="flex flex-col sm:flex-row items-center gap-4 w-full justify-center" data-id="element-180">
              <Button variant="primary" size="lg" onClick={scrollToPricing} className="w-full sm:w-auto min-w-[280px]" data-id="element-181">
                Quiero la guía ahora <ArrowRight className="ml-2 h-5 w-5" data-id="element-182" />
              </Button>
            </div>
            <p className="text-sm text-forest/60 font-medium" data-id="element-183">
              <span className="line-through text-forest/40" data-id="element-184">$19 USD</span>{' '}
              <span className="text-terracotta font-bold" data-id="element-185">$6.39 USD</span> —
              Acceso inmediato
            </p>
          </motion.div>

          {/* Hero image */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.6
        }} className="mt-12 max-w-lg mx-auto" data-id="element-186">
            <div className="relative" data-id="element-187">
              <div className="absolute -inset-4 bg-sage/15 rounded-[2rem] blur-2xl" data-id="element-188"></div>
              <img src="https://cdn.magicpatterns.com/uploads/unZichhruR5hEhX3jhYG9B/pequesalud_shopify.png" alt="PequeSalud Natural - Guía práctica de remedios naturales para enfermedades comunes en niños" className="relative rounded-2xl shadow-xl shadow-sage/20 w-full object-cover aspect-[3/2] border-2 border-white" data-id="element-189" />
              <div className="absolute -bottom-3 -right-3 bg-white rounded-xl px-4 py-2 shadow-lg border border-sage/10" data-id="element-190">
                <span className="text-sm font-semibold text-forest" data-id="element-191">
                  🌿 Calma y confianza
                </span>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}